<template>
  <div>
    <div class="row" style="margin-top: 40px;padding: 20px">
      <div class="col-12">


        <div>


          <div class="row flex-row justify-content-between" style="padding-bottom: 20px; border-bottom: solid 1px rgba(223,223,223,0.37);margin-bottom: 40px">
            <div class="col-2" style="align-content: center;">
              <strong>افزودن نوشته جدید</strong>
            </div>
            <div class="col-2 align-content-end">
              <div class="d-flex flex-row p-2">
                <div>
                  <CButton v-if="status_form==0" @click="login()">

                    انتشار
                  </CButton>
                </div>
                <div>
                  <CButton v-if="status_form!=0" @click="login()">
                    ویرایش نوشته
                  </CButton>
                </div>
                <!--            <div >-->
                <!--              <CButton class="form__btn" @click="reload_data_content()">-->
                <!--                بروزرسانی-->
                <!--              </CButton>-->
                <!--            </div>-->
              </div>
            </div>

          </div>


          <div>
            <div class="row">
              <div class="col-4" style="font-size: 12px;padding-left: 5px;padding-right: 5px">
                <CInput
                    v-model="title"
                    label="عنوان نوشته"
                    placeholder="عنوان"
                    vertical
                />
              </div>
              <div class="col-2" style="font-size: 12px;padding-left: 5px;padding-right: 5px">
                <CInput
                    v-model="keyword"
                    label="کلید واژه"
                />


              </div>
              <div class="col-3" style="align-content: center;padding-left: 5px;padding-right: 5px">
                <treeselect
                    v-if="loaded_page"
                    v-model:modelValue="value_category"
                    :normalizer="normalizer_category"
                    :multiple="true"
                    :options="options_category"
                    :async="false"
                    placeholder="دسته بندی نوشته را انتخاب کنید"

                />

                <!--                <div >-->
                <!--                  <label style="color:white">دسته بندی نوشته</label>-->
                <!--                  <select v-model="value_category">-->
                <!--                    <option value="0" :selected="ads_all_episode==0">عدم نمایش</option>-->
                <!--                    <option value="1" :selected="ads_all_episode==1">نمایش</option>-->
                <!--                  </select>-->
                <!--                </div>-->

              </div>
              <div class="col-3" style="font-size: 12px;padding-left: 5px;padding-right: 5px">
                <div><br></div>
                <date-picker
                    v-model="publish_date"
                    label="تاریخ انتشار"
                    type="datetime"
                    format="YYYY-MM-DD HH:mm:ss"
                    input-format="YYYY-MM-DD HH:mm:ss"
                    alt-format="YYYY-MM-DD HH:mm:ss"
                    display-format="jYYYY/jMM/jDD HH:mm:ss"

                />

              </div>
              <div class="col-4"
                   style="font-size: 12px;margin-top: 20px;align-content: center;padding-left: 5px;padding-right: 5px">
                <CInput
                    v-model="seo_title"
                    label="سئو عنوان"
                />
                <SeoProgress :min_perfect="50" :max_perfect="60" :string="seo_title"/>

              </div>
              <div class="col-4" style="font-size: 12px;align-content: center;padding-left: 5px;padding-right: 5px">
                <CInput
                    v-model="favorite_url"
                    label="لینک نوشته"

                    placeholder="لینک"
                />

              </div>
              <div class="col-4" style="font-size:13px;margin-top: 20px">
                <CTextarea
                    v-model="seo_summary"
                    label="سئو توضیحات"/>
                <SeoProgress :min_perfect="120" :max_perfect="150" :string="seo_summary"/>
              </div>

            </div>
            <div class="row">
              <div class="col-9" style="font-size: 12px">
                <YoastSeo
                    :focusKeyword="keyword"
                    :metaTitle="seo_title"
                    :metaDescription="seo_summary"
                    :description="content_html"
                />
              </div>
              <div class="col-3" style="cursor: pointer;margin-top: 30px">

                <ImageSelector label=" تصویر (400*800)"
                               v-model:previewImage="previewImage"
                               @imagefile="(n) => file = n"/>

              </div>
            </div>

            <div class="row"
                 style="background: white;color: black;border-radius: 10px;margin-left: 5px;margin-right: 5px;margin-top: 20px">

              <div class="col-12" col="12" style="margin-top: 20px">
                <editorjs v-if="loaded_page"
                          editor_id="add_new_editor"
                          v-model:first_content="content_json"
                          v-model:content_json="content_json"
                          v-model:content_text="content_text"
                          v-model:content_html="content_html"
                />

              </div>

            </div>
            <br>
          </div>


        </div>

      </div>
    </div>

  </div>

</template>

<script>
import editorjs from "@/views/includes/editorjs.vue";
import axios from "axios";

import 'vue3-treeselect/dist/vue3-treeselect.css'
import Treeselect from 'vue3-treeselect'
import {ASYNC_SEARCH} from 'vue3-treeselect'

import ReadabilitySeoRate from "@/views/includes/ReadabilitySeoRate";
import ImageSelector from "@/views/CustomComponent/ImageSelector.vue";
import CTextarea from "@/views/CustomComponent/CTextarea.vue";
import CButton from "@/views/CustomComponent/CButton.vue";
import YoastSeo from "@/views/includes/YoastSeo.vue";
import SeoProgress from "@/views/includes/SeoProgress.vue";
import DatePicker from 'vue3-persian-datetime-picker'
import 'vue3-treeselect/dist/vue3-treeselect.css'

const simulateAsyncOperation = fn => {
  setTimeout(fn, 2000)
}


export default {
  name: 'Login',
  components: {
    YoastSeo,
    CButton,
    CTextarea,
    ImageSelector,
    ReadabilitySeoRate,
    Treeselect,
    editorjs,
    DatePicker,
    SeoProgress
    // ckeditor: CKEditor.component
  },
  data() {

    return {
      editor: null,
      loaded_page: false,
      content_json: {},
      content_text: '',
      content_html: '',
      value_category: [],
      value_tags: [],
      value_keywords: [],
      // define options
      image_upload: '',
      options_category: [],
      normalizer_category(node) {
        return {
          id: node.id,
          label: node.cat_title,
          children: node.children,
        }
      },

      load_tags({action, searchQuery, callback}) {

        if (action === ASYNC_SEARCH) {
          simulateAsyncOperation(() => {
            let options;
            axios.post('/admin/blog/search_blog_tags', {
              search: searchQuery,

            }).then(function (response) {
              options = response.data;
              callback(null, options);
            })
                .catch(function (error) {
                  console.log(error);
                });

          })
        }
      },
      normalizer_tags(node) {
        return {
          id: node.title,
          label: node.title,
        }
      },
      // editor: ClassicEditor,
      editorData: '',
      title: '',
      favorite_url: '',
      seo_title: '',
      keyword: '',
      summary: '',
      seo_summary: '',
      tags: '',
      file: null,
      publish_date: '',

      previewImage: null,
      image: '',

      details: [],
      status_form: 0,

    }
  },
  mounted() {

    this.get_categories();
    if (this.$route.params.post_id != null) {
      this.status_form = this.$route.params.post_id;
      this.get_post_info();
    } else {
      this.loaded_page = true
    }
  },
  watch: {
    '$route.params.post_id': function () {
      this.get_categories();
    },
    // 'editorData': function () {
    //   let tmp = document.createElement("DIV");
    //   tmp.innerHTML = this.editorData;
    //   this.content_text = tmp.textContent || tmp.innerText || "";
    //
    //   this.content_html = this.editorData;
    // },

  },
  methods: {

    editDetails(item) {
      // this.$set(this.items[item.id], '_toggled', !item._toggled)
      this.name = this.items[item.id].name
      this.color = this.items[item.id].color
      this.description = this.items[item.id].description
      this.previewImage = this.items[item.id].image
      this.status_form = this.items[item.id].cat_id;
      // this.$nextTick(() => {
      //     this.collapseDuration = 0
      // })
    },
    get_categories() {
      var self = this;
      var formData = new FormData();
      axios.post('/admin/blog/get_categories_with_children', formData, {}).then(function (response) {
        // console.log("cats is "+response.data.groups);
        // console.log("cats is "+items);

        var content_cats = response.data;

        // items = content_cats.orders;
        self.options_category = content_cats.orders;
        // console.log("cats is "+items);
        // self.description = '';
        // localStorage.setItem("api_token", response.data.access_token);
        // self.$router.push({ path: 'notes' });
      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_post_info() {
      var self = this;
      var formData = new FormData();
      formData.append('post_id', self.status_form);
      axios.post('/admin/blog/post_info', formData, {}).then(function (response) {
        var post_data = response.data;

        self.file = post_data.post.post_image;
        post_data.post.categories.forEach((val) => {
          self.value_category.push(val.category_id);
        });
        // post_data.post.tags.forEach((val) => {
        //   self.value_tags.push(val.tag.title.title);
        // });

        // self.value_category = post_data.post.categories;
        //  self.options_=post_data.post.tags;
        self.previewImage = post_data.post.image
        // self.value_keywords=post_data.post.keywords;
        self.title = post_data.post.post_title;
        self.favorite_url = post_data.post.slug;
        self.publish_date = post_data.post.publish_date;

        self.content_json = JSON.parse(post_data.post.post_summary);

        self.seo_summary = post_data.post.meta_description;
        self.seo_title = post_data.post.seo_title;
        self.keyword = post_data.post.post_keyword;
        self.loaded_page = true

        // localStorage.setItem("api_token", response.data.access_token);
        // self.$router.push({ path: 'notes' });
      }).catch(function (error) {

        console.log(error);
      });


    },


    login() {
      console.log("add news insert called")
      let self = this;
      const formData = new FormData()
      let url;
      if (self.status_form == 0) {
        url = "/admin/blog/insert_post";
      } else {
        url = "/admin/blog/update_post";
        formData.append('post_id', this.status_form)

      }

      formData.append('post_image', this.file)
      formData.append('cat_list', this.value_category)
      formData.append('tags', this.value_tags)
      formData.append('name', this.title)
      formData.append('url', this.favorite_url)
      formData.append('publish_date', this.publish_date)

      formData.append('text', JSON.stringify(this.content_json))
      formData.append('meta_desc', this.seo_summary)
      formData.append('meta_title', this.seo_title)
      formData.append('keyword', this.keyword)

      axios.post(url, formData, {}).then((res) => {
        // self.$root.modal_component.show_api_response_modals(res);
        if (self.status_form == 0) {
          self.$router.go(-1)
        }else{
          self.get_post_info();
        }

      }).catch(function (error) {

        console.log(error);
      });

    }
  }
}


</script>
<style>

</style>
